import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

const UserList = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get('https://aaryanholidays.in/backend/user');
        setTestimonials(response.data);
      } catch (error) {
        console.error('There was an error fetching the User!', error);
      }
    };
    fetchTestimonials();
  }, []);

  

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        User List
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
             
             
            </TableRow>
          </TableHead>
          <TableBody>
            {testimonials.map((testimonial) => (
              <TableRow key={testimonial.id}>
                
                <TableCell>{testimonial.first_name}</TableCell>
                <TableCell>{testimonial.last_name}</TableCell>
                <TableCell>{testimonial.email}</TableCell>
                <TableCell>{testimonial.phone}</TableCell>
               
                
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserList;
